// extracted by css-extract-rspack-plugin
export default {"recordingCard":"ZHgzglA5PiEiCPCB","carousel":"HEQrCPEEJUgrF6jJ","recordingHeader":"MxpSb0_U8U8TDI6Q","playerContainer":"zntV7TovWwQ0tPvy","playerStatus":"odzbsppkkU4JElwQ"};